export enum IrisButtonTarget {
  BLANK = '_blank',
  PARENT = '_parent',
  SELF = '_self',
  TOP = '_top'
}
